export const navigationRoutes = {
  homepage: "/",
  checkout: "/checkout",
  aiBuilder: "/ai-builder",
  worthItBuilder: "/pcbuilder",
  buildGallery: "/builds-gallery",
  pricelist: "/pricelist",
  pcPackage: "/pc-package",
  reviews: "/reviews",
  googleReviews: "/google-reviews",
  facebookReviews: "/facebook-reviews",
  diyBuilder: "/diy-builder",
  poweredBy: "/powered-by/:id",
  amdGamersFirst: "/amd-gamers-first",
  powered_builds: "/powered-builds",
  brands: "/brands",
  extra_service: "/pcw-extra-service",
  promotionals: "/promotional",

  //===== when login
  pcwProfile: "/profile",
  pcwOrder: "/orders",
  pcwAccountSecurity: "/account-security",
  affiliate: "/affiliate",
  userCart: "/user-cart",
  productWarranty: "/product-warranty",
  address: "/address",
  accountSecurity: "/account-security",
  myBuilds: "/my-builds",
  blogs: "/blogs",
  pcWorthCare: "/pc-worth-cares",

  // Resources
  termsAndConditions: "/terms-and-conditions",
  howToOrder: "/how-to-order",
  frequentlyAskedQuestions: "/frequently-ask-question",
  privacyPolicy: "/privacy-policy",

  // Contact
  contactUs: "/contact-us",

  // Brands
  nvidia: "/nvidia",
};
